import script from "./WalletBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./WalletBox.vue?vue&type=script&lang=ts&setup=true"

import "./WalletBox.vue?vue&type=style&index=0&id=3baffbfa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3baffbfa"]])

export default __exports__